(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery-content"] && !Shopify.designMode) return;
  try {
    function addMuteButton(video) {
    if (video.dataset.muteButtonAdded) return;
    video.dataset.muteButtonAdded = 'true';

    var btn = document.createElement('button');
    btn.setAttribute('type', 'button');
    btn.setAttribute('aria-label', 'Toggle sound');
    btn.style.cssText = [
      'position:absolute',
      'bottom:12px',
      'right:12px',
      'z-index:10',
      'background:rgba(0,0,0,0.55)',
      'border:none',
      'border-radius:50%',
      'width:36px',
      'height:36px',
      'cursor:pointer',
      'display:flex',
      'align-items:center',
      'justify-content:center',
      'color:#fff',
      'font-size:16px',
      'transition:background 0.2s'
    ].join(';');
    btn.innerHTML = '🔇';

    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      video.muted = !video.muted;
      btn.innerHTML = video.muted ? '🔇' : '🔊';
    });

    var container = video.closest('.product-media-container');
    if (container) {
      container.style.position = 'relative';
      container.appendChild(btn);
    }
  }

  // Handle videos already in DOM
  document.querySelectorAll('.product-media video').forEach(addMuteButton);

  // Handle deferred/lazy-loaded videos
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.tagName === 'VIDEO') {
          addMuteButton(node);
        }
        node.querySelectorAll && node.querySelectorAll('video').forEach(addMuteButton);
      });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
  } catch(e) { console.error(e); }
})();

})();
